/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/AppointmentSelect/Content/Content/Content/Content/Appointments/Appointment/Booking/Content"
  
}) {
let appointmentBooking0ValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.0',
})
let tabSelectedTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.time_zone_id',
})
let aggregateData = fromHelpers.getBookingTime(appointmentBooking0ValueData, tabSelectedTimeZoneIdValueData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let appointmentBooking0LocationIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.0.location.id',
})
let tabSelectedVaxiomLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.vaxiom_location_id',
})
let aggregateData1 = fromAggregate.equals(appointmentBooking0LocationIdValueData, tabSelectedVaxiomLocationIdValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let appointmentBooking0LocationNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.0.location.name',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment.booking.0"
 data="tab.selected.time_zone_id"
 aggregate="helpers.js getBookingTime"
 text={aggregateData}
 size="normal"
 weight="regular"
 color={dtColorsNeutral600}
/>
<fromFlow.When is={!aggregateData1}>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text=","
 size="normal"
 weight="regular"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment.booking.0.location.name"
 text={appointmentBooking0LocationNameValueData}
 size="normal"
 weight="regular"
 color={dtColorsNeutral600}
/>
</div>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}